import React from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import Dialog from 'components/dialog'
import DeleteOutlinedIcon from 'components/material-symbol/icons/Delete'
import { useSnackbar, useSnackbarError, useSnackbarSuccess } from 'lib/snackbar'
import { useDeleteCoachCampaign } from './api-hooks'

export default function DeleteDraftDialog({
  campaign,
  isOpen,
  onClose,
  onDeleted,
}) {
  const { enqueueSnackbar } = useSnackbar()
  const showError = useSnackbarError(enqueueSnackbar)
  const showSuccess = useSnackbarSuccess(enqueueSnackbar)
  const [deleteCampaign, { loading }] = useDeleteCoachCampaign()

  const handleDelete = async () => {
    try {
      const { data } = await deleteCampaign({
        variables: { id: campaign.id },
        update: (cache, { data: result }) => {
          if (!result?.deleteCoachCampaign?.success) return
          cache.evict({
            id: cache.identify({
              __typename: 'CoachCampaign',
              id: campaign.id,
            }),
          })
          cache.gc()
        },
      })
      const response = data?.deleteCoachCampaign
      if (!response?.success) {
        showError(response?.message)
        return
      }
      showSuccess('Draft deleted')
      onClose()
      onDeleted?.()
    } catch (e) {
      showError()
    }
  }

  return (
    <Dialog isOpen={isOpen} onClose={onClose} maxWidth="xs">
      {({ closeDialog }) => (
        <>
          <DialogTitle>Delete Draft</DialogTitle>
          <DialogContent>
            <Typography variant="body1" gutterBottom>
              {campaign.name ? `“${campaign.name}”` : 'This draft'} will be
              deleted. This can’t be undone.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button color="primary" onClick={closeDialog}>
              Cancel
            </Button>
            <Button
              color="primary"
              variant="contained"
              onClick={handleDelete}
              disabled={loading}
              startIcon={<DeleteOutlinedIcon />}
            >
              Delete
            </Button>
          </DialogActions>
        </>
      )}
    </Dialog>
  )
}

DeleteDraftDialog.propTypes = {
  campaign: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
  }).isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onDeleted: PropTypes.func,
}
